import { useState, type ReactNode } from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '@strivelabs/ui-core/lib/utils';
import { CountPill } from '@/components/common/CountPill';
import { SECTION_LABEL } from '../taskTheme';

interface TaskSectionProps {
  title: string;
  /** How many things the block holds, shown as the platform's count pill. */
  count?: number;
  children: ReactNode;
}

/** A named, collapsible block of the panel. */
export const TaskSection = ({ title, count, children }: TaskSectionProps) => {
  const [ open, setOpen ] = useState(true);

  return (
    <section className="mt-4 first:mt-4">
      <div className="mb-2 flex items-center justify-between">
        <button
          type="button"
          aria-expanded={open}
          className="inline-flex select-none items-center gap-2"
          onClick={() => setOpen(!open)}
        >
          <span className={SECTION_LABEL}>{title}</span>
          {count === undefined ? null : <CountPill count={count} />}
          <ChevronDown
            className={cn(
              'size-[13px] shrink-0 stroke-2 text-[#9A9A9A] transition-transform',
              open ? '' : '-rotate-90',
            )}
            aria-hidden
          />
        </button>
      </div>
      {open ? children : null}
    </section>
  );
};
